import React from 'react';
import { formatCurrency } from './formatters';
import './WeightProfilePanel.css';

/**
 * WeightProfilePanel — read-only "How we weighted this" explainer.
 * Renders null for Heavy / explicit-weights results (weightProfile null).
 * Deliberately no controls: owners cannot tune their own weights (spec §6).
 */
function WeightProfilePanel({ weightProfile }) {
  if (!weightProfile) return null;
  const { label, rationale, factsUsed = {} } = weightProfile;
  return (
    <section className="weight-profile-panel">
      <h3 className="weight-profile-heading">How we weighted this</h3>
      <p className="weight-profile-label-line">
        Profile: <strong>{label}</strong>
      </p>
      <p className="weight-profile-rationale">{rationale}</p>
      <ul className="weight-profile-facts">
        <li>Weighted EBITDA: {formatCurrency(factsUsed.weightedEBITDA)}</li>
        <li>Weighted SDE: {formatCurrency(factsUsed.weightedSDE)}</li>
        {factsUsed.totalAssetsAvailable && (
          <li>Total assets: {formatCurrency(factsUsed.totalAssets)}</li>
        )}
      </ul>
    </section>
  );
}

export default WeightProfilePanel;
